// === GENERATED FILE ===
// DO NOT EDIT DIRECTLY, EDIT sh-checkbox.lit.scss INSTEAD!
import { css } from 'lit-element';
export default css`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-checkbox-inner-width=1rem] - checkbox width
   */
  --sh-checkbox-inner-width: 1rem;
  /* 
   * @cssprop [--sh-checkbox-inner-height=1rem] - checkbox height
   */
  --sh-checkbox-inner-height: 1rem;
  /* 
   * @cssprop [--sh-checkbox-outer-width=1.5rem] - checkbox outer width
   */
  --sh-checkbox-outer-width: 1.5rem;
  /* 
   * @cssprop [--sh-checkbox-outer-height=1.5rem] - checkbox outer height
   */
  --sh-checkbox-outer-height: 1.5rem;
  /* 
   * @cssprop [--sh-checkbox-tick-line-height=0.875rem] - checkbox tick line height
   */
  --sh-checkbox-tick-line-height: 0.875rem;
  /* 
   * @cssprop [--sh-checkbox-tick-font-size=0.875rem] - tick font size
   */
  --sh-checkbox-tick-font-size: 0.875rem;
  /* 
   * @cssprop [--sh-checkbox-border-width=0.125rem] - checkbox border width
   */
  --sh-checkbox-border-width: 0.125rem;
  /* 
   * @cssprop [--sh-checkbox-border-radius=0.125rem] - checkbox border radius
   */
  --sh-checkbox-border-radius: 0.125rem;
  /* 
   * @cssprop [--sh-checkbox-label-line-height=1.25rem] - checkbox label line height
   */
  --sh-checkbox-label-line-height: 1.25rem;
  /* 
   * @cssprop [--sh-checkbox-margin-right=0.5rem] - checkbox margin right
   */
  --sh-checkbox-margin-right: 0.5rem;
  /* 
   * @cssprop [--sh-checkbox-margin-around-checkbox=0.25rem] - margin around checkbox
   */
  --sh-checkbox-margin-around-checkbox: 0.25rem;
  /* 
   * @cssprop [--sh-checkbox-text-indent=-0.0625rem] - tick text indent
   */
  --sh-checkbox-text-indent: -0.0625rem;
  /* 
   * @cssprop [--sh-checkbox-outline-offset=-0.125rem] - outline ofset
   */
  --sh-checkbox-outline-offset: -0.125rem;
  /* 
   * @cssprop [--sh-checkbox-label-width=2rem] - label width
   */
  --sh-checkbox-label-width: 2rem;
  /* 
   * @cssprop [--sh-checkbox-padding=0rem] - checkbox top and bottom padding
   */
  --sh-checkbox-padding: 0rem;
  /* 
   * @cssprop [--sh-checkbox-label-padding=0rem] - label padding
   */
  --sh-checkbox-label-padding: 0rem;
}

:host {
  display: flex;
  flex-direction: row;
  width: 100%;
  color: var(--text-primary);
  -webkit-font-smoothing: antialiased !important;
  text-rendering: optimizeLegibility !important;
  -moz-osx-font-smoothing: grayscale !important;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  outline: none;
  align-items: center;
  width: 100%;
  cursor: pointer;
  position: relative;
  font: var(--body-1);
  height: fit-content;
  padding: var(--sh-checkbox-padding) 0;
}

#checkbox {
  width: var(--sh-checkbox-inner-width);
  height: var(--sh-checkbox-inner-height);
  opacity: 0;
  position: absolute;
  margin: 0 var(--sh-checkbox-margin-around-checkbox);
  top: var(--sh-checkbox-margin-around-checkbox);
  align-self: flex-start;
}

.checkboxLabel {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: calc(100% - var(--sh-checkbox-label-width));
  line-height: var(--sh-checkbox-label-line-height);
  padding: var(--sh-checkbox-label-padding);
}

#pseudoCheckbox::before {
  border-style: solid;
  border-width: var(--sh-checkbox-border-width);
  border-color: rgba(var(--ui-1), var(--opacity-4));
  width: var(--sh-checkbox-inner-width);
  height: var(--sh-checkbox-inner-height);
  position: absolute;
  margin: var(--sh-checkbox-margin-around-checkbox);
  border-radius: var(--sh-checkbox-border-radius);
  content: "\\E0E6";
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  visibility: visible;
  box-sizing: border-box;
  transition: var(--transition-time) all ease-in-out;
  font-family: "sh-icons";
  font-weight: 700;
  color: transparent;
  font-size: var(--sh-checkbox-tick-font-size);
  text-indent: var(--sh-checkbox-text-indent);
  line-height: var(--sh-checkbox-tick-line-height);
  text-align: center;
  vertical-align: middle;
}

#pseudoCheckbox {
  width: var(--sh-checkbox-outer-width);
  height: var(--sh-checkbox-outer-height);
  visibility: hidden;
  cursor: pointer;
  position: relative;
  margin-right: var(--sh-checkbox-margin-right);
  align-self: flex-start;
  display: inline-block;
}

:host(.touch-device) #pseudoCheckbox {
  visibility: visible;
}

.item-focused:before {
  outline: var(--focus-outline);
  outline-offset: var(--sh-checkbox-outline-offset);
}

:host([active]) #pseudoCheckbox::before {
  color: var(--base-3);
  background: rgba(var(--ui-2), var(--opacity-1));
  border-color: transparent;
}

:host([neutral][active]:not([disabled])) #pseudoCheckbox::before {
  background: rgba(var(--ui-1), var(--opacity-3));
}

:host(:not([active]):hover:not(.touch-device)) #pseudoCheckbox::before {
  border-color: rgba(var(--ui-2), var(--opacity-1));
}

:host(:not([active]):hover:not(.touch-device)) #pseudoCheckbox::before {
  border-color: rgba(var(--ui-1), var(--opacity-3));
}

:host([active]:hover:not(.touch-device)) #pseudoCheckbox::before {
  background: rgba(var(--ui-3), var(--opacity-1));
}

:host([neutral][active]:hover:not(.touch-device)) #pseudoCheckbox::before {
  background: rgba(var(--ui-1), var(--opacity-2)) !important;
}

:host([indeterminate]) #pseudoCheckbox::before {
  content: "\\E011";
}

:host([disabled]) {
  cursor: not-allowed;
  pointer-events: none;
  color: var(--text-disabled);
}

:host([disabled]:not([active])) #pseudoCheckbox::before {
  border-color: rgba(var(--ui-1), var(--opacity-5));
}

:host([active][disabled]:not([neutral])) #pseudoCheckbox::before {
  background: rgba(var(--ui-2), var(--opacity-5));
}

:host([neutral][active][disabled]) #pseudoCheckbox::before {
  background: rgba(var(--ui-1), var(--opacity-5));
}`;